var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Environment_1 = __importDefault(require("@hendersonengineers/types/Environment"));
const isDevelopment_1 = __importDefault(require("./isDevelopment"));
const isStage_1 = __importDefault(require("./isStage"));
const isProduction_1 = __importDefault(require("./isProduction"));
const ENVIRONMENT_CACHE_KEY = 'HENDERSON_CACHE_CURRENT_ENVIRONMENT';
function getEnvironment(url) {
    if (!url) {
        if (!window[ENVIRONMENT_CACHE_KEY]) {
            window[ENVIRONMENT_CACHE_KEY] = _getEnvironment(window.location.href);
        }
        return window[ENVIRONMENT_CACHE_KEY];
    }
    return _getEnvironment(url);
}
function _getEnvironment(url) {
    if ((0, isDevelopment_1.default)(url)) {
        return Environment_1.default.Development;
    }
    if ((0, isStage_1.default)(url)) {
        return Environment_1.default.Stage;
    }
    if ((0, isProduction_1.default)(url)) {
        return Environment_1.default.Production;
    }
    return 1;
}
exports.default = getEnvironment;
//# sourceMappingURL=getEnvironment.js.map